import React from 'react';
import PropTypes from 'prop-types';

/**
 * Styled confirmation dialog — replaces browser confirm().
 * Never dismisses on outside click; requires explicit button action.
 */
const ConfirmModal = ({
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = true,
  onConfirm,
  onCancel,
}) => (
  <div className="modal-overlay">
    <div className="modal" style={{ maxWidth: '420px' }}>
      <div className="modal-header">
        <h2 className="modal-title">{title}</h2>
      </div>
      <p style={{ color: 'var(--color-text)', fontSize: '14px', lineHeight: '1.5' }}>
        {message}
      </p>
      <div className="modal-actions">
        <button className="btn btn-secondary" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
          className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

ConfirmModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  danger: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmModal;
